import * as _ from 'lodash';
import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Card, CardPublished } from '../../shared/models/card.model';
import { ApiService } from '../../shared/services/api.service';
import { SettingsResult } from '../../shared/models/game-settings.model';
import { APP_ROLE, CATEGORIES, SocketService } from '../../shared/services/socket.service';
import { isNullOrUndefined } from 'util';
import { MAT_SNACK_BAR_DATA, MatDialog, MatSnackBar } from '@angular/material';
import { Group } from '../../shared/models/group.model';
import { StorageService } from '../../shared/services/storage.service';
import { GameService, GameState } from '../../shared/services/game.service';
import { CountdownTimerComponent } from '../../shared/components/countdown-timer/countdown-timer.component';
import { DialogGroupsSelect } from './dialog-groups-select/dialog-groups-select';
import { DialogResultConfirmComponent } from './dialog-result-confirm/dialog-result-confirm.component';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { GroupsService } from '../../shared/services/groups-service';
import { Subscription } from 'rxjs/Subscription';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss'],
  providers: [ApiService]

})
export class GameComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(CountdownTimerComponent)
  timerComponent: CountdownTimerComponent;

  sessionCode: Observable<string>;
  settingsObs: Observable<SettingsResult>;
  settings: SettingsResult;

  cards: Card[];
  cardsPublished: CardPublished[];

  searchText: string;
  foundCard: Card;
  cardPublished: CardPublished;

  publishButtonState: PublishButtonState = PublishButtonState.PUBLISH;
  publishButtonColor = 'primary';

  groupSelected: Group;

  gameStateSubscription: Subscription;
  onCardPublishedSubscription: Subscription;
  onCardUnPublishedSubscription: Subscription;
  onRequestTimeSyncSubscription: Subscription;

  scoresToggleControl = new FormControl(true, [
    Validators.required
  ]);

  //

  categories = CATEGORIES;
  currentCategory: string;
  filtered: CardPublished[] = [];

  constructor(private apiService: ApiService,
              private socketService: SocketService,
              private storageService: StorageService,
              private router: Router,
              public groupsService: GroupsService,
              public gameStateService: GameService,
              public dialog: MatDialog,
              public snackBar: MatSnackBar) {

    this.getCards();

    this.getSessionCode()
      .subscribe(sessionCode => {
        this.getSettings(sessionCode)
          .subscribe( settings => {
            this.initBySettings(settings);
          });
      });
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    this.gameStateSubscription.unsubscribe();
    this.onCardPublishedSubscription.unsubscribe();
    this.onCardUnPublishedSubscription.unsubscribe();
    this.onRequestTimeSyncSubscription.unsubscribe();
  }

  //

  getSessionCode(): Observable<string> {
    return this.sessionCode = this.storageService.getSessionCode();
  }

  getSettings(sessionCode): Observable<SettingsResult> {
    return this.settingsObs = this.apiService.getSettings(sessionCode);
  }

  initBySettings(settings: SettingsResult) {

    this.settings = settings;

    this.cardsPublished = settings.publishedCards;

    // Set seconds for clock
    this.timerComponent.time = settings.duration * 60;

    // GroupService
    this.groupsService.initWithSettings(settings);
    // SocketService
    this.initSocketService(settings.sessionCode);
    // GameState Service
    this.initGameService();
    //
    this.start();
  }

  private initSocketService(sessionCode) {
    this.socketService.initSocket(sessionCode, APP_ROLE.REMOTE_ROLE);


    this.onCardPublishedSubscription = this.socketService.onCardPublished().subscribe((data: CardPublished) => {
      this.snackBar.openFromComponent(CardSnackComponent, {
        duration: 500,
        data: {message: 'Resultaat gepubliceerd!'}
      });
      console.warn('CARD PUBLISHJED', data);
    });

    this.onCardUnPublishedSubscription = this.socketService.onCardUnpublished().subscribe((data: CardPublished) => {
      this.snackBar.openFromComponent(CardSnackComponent, {
        duration: 500,
        data: {message: 'Kaart verwijderd!'}
      });
      console.warn('CARD UNPUBLISHJED', data);
    });

    this.onRequestTimeSyncSubscription = this.socketService.onRequestTimeSync().subscribe( () => {
      this.socketService.timeSync(this.timerComponent.seconds, this.gameStateService.state);
    });

    this.socketService.onFilterCategory().subscribe((data: string) => {
      console.log('filter category:' , data);
      this.currentCategory = data;
    });
  }

  private initGameService() {
    this.gameStateSubscription = this.gameStateService.stateObservable.subscribe((gameState: GameState) => {
      switch (gameState) {
        case GameState.PREPARE:
          break;
        case GameState.START:
          this.timerComponent.start();
          this.socketService.gameStart();
          break;
        case GameState.PAUSE:
          this.timerComponent.pause();
          this.socketService.gamePause();
          break;
        case GameState.RESUME:
          this.timerComponent.resume();
          this.socketService.gameResume();
          break;
        case GameState.STOP:
          this.timerComponent.stop();
          this.socketService.gameStop();
          this.socketService.disconnect();
          this.storageService.clearSessionCode().subscribe(data => {
            console.log('sessionCode cleared local:', data);
            this.router.navigate(['/remote/settings']);
          });

          break;
        default:
      }
    });
  }

  start() {
    this.gameStateService.state = GameState.START;
  }

  pause() {
    this.gameStateService.state = GameState.PAUSE;
  }

  resume() {
    this.gameStateService.state = GameState.RESUME;
  }

  stop() {
    this.openDialogResultConfirm();
  }

  reset() {
    this.gameStateService.state = GameState.PREPARE;
  }

  onInputFocus(input) {
    if (input.value !== '') {
      input.value = '';
    }
  }

  onSearch(value: string) {
    this.searchText = value;

    this.foundCard = this.searchForCard(this.searchText);
    console.table(this.foundCard);
    this.cardPublished = this.searchForMatchingCardPublished(this.foundCard ? this.foundCard.id.toString() : '');
    console.log(this.cardPublished);
    //
    this.setPublishButtonState();
  }

  searchForCard(id: string): Card {
    const foundCard: Card = _.filter(this.cards, card => {
      return card.id.toString() === id;
    })[0];

    if (!isNullOrUndefined(foundCard)) {
      return foundCard;
    } else {
      return null;
    }
  }

  publishButtonClick(event) {
    console.log(event);

    switch (this.publishButtonState) {
      case PublishButtonState.PUBLISH:
        this.openDialogGroupsSelect();
        break;
      case PublishButtonState.UNPUBLISH:
        this.apiService.unpublish(this.settings.uuid, this.cardPublished.id)
          .subscribe(cardsPublished => {
            this.cardsPublished = cardsPublished;
            this.socketService.unpublishCard(this.cardPublished);
            this.onSearch(this.cardPublished.id.toString());
          });
        break;
      default :
        break;
    }

  }

  searchForMatchingCardPublished(id: string = ''): CardPublished {
    const matchCard: CardPublished = _.filter(this.cardsPublished, card => {
      return card.id.toString() === id;
    })[0];

    if (!isNullOrUndefined(matchCard)) {
      return matchCard;
    } else {
      return null;
    }
  }

  setPublishButtonState() {
    if (!isNullOrUndefined(this.cardPublished)) {
      this.publishButtonState = PublishButtonState.UNPUBLISH;
    } else {
      this.publishButtonState = PublishButtonState.PUBLISH;
    }

    this.setPublishButtonColor();
  }

  setPublishButtonColor() {
    switch (this.publishButtonState) {
      case PublishButtonState.PUBLISH:
        this.publishButtonColor = 'primary';
        break;
      case PublishButtonState.UNPUBLISH:
        this.publishButtonColor = 'warn';
        break;
      default :
        this.publishButtonColor = 'primary';
        break;
    }
  }

  getGroup(): Group {
    return this.groupsService.groupItems[this.cardPublished.group];
  }

  getCards() {
    this.apiService.getCards()
      .subscribe(data => {
        this.cards = data;
        console.table(this.cards);
        const categories = _.flatMap(_.uniqBy(data, 'category'), (card: CardPublished) => {
          return card.category;
        });
        console.log('categories', categories);
        this.storageService.setCategories(categories);
      });
  }

  //

  openDialogGroupsSelect(): void {
    let dialogRef = this.dialog.open(DialogGroupsSelect, {
      data: {groups: this.groupsService.groupItems}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);

      this.groupSelected = result;

      if (!isNullOrUndefined(result)) {

        this.groupSelected = result;

        this.publishCard(this.settings.uuid, this.groupSelected, this.foundCard);
      }
    });
  }

  //

  openDialogResultConfirm(): void {
    let dialogRef = this.dialog.open(DialogResultConfirmComponent, {
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);

      if (!isNullOrUndefined(result)) {

        this.gameStateService.state = GameState.STOP;

      }

    });
  }

  //

  publishCard(uuid: string, group: Group, card: Card) {
    console.log('publish card! with:', uuid, group, card);
    const publishedCard: CardPublished = {
      group: group.id,
      id: card.id,
      answer: card.answer,
      difficulty: card.difficulty,
      category: card.category,
      question: card.question,
      questionImage: card.questionImage,
      answerImage: card.answerImage,
      publishedAt: new Date()
    };
    this.apiService.publish(this.settings.uuid, publishedCard)
      .subscribe(data => {
        console.log('card published!');
        this.cardsPublished = data;
        console.log('cardsPublished:', this.cardsPublished);
        this.socketService.publishCard(publishedCard);
        this.onSearch(publishedCard.id.toString());
      });
  }

  onScoresToggleChange() {
    this.socketService.scoresToggle(this.scoresToggleControl.value);
  }



  ///

  filter(category: string) {
    this.currentCategory = category;

    console.log(this.currentCategory);

    this.socketService.filterCategory(this.currentCategory);
  }
}

export enum PublishButtonState {
  PUBLISH = 'publiceer',
  UNPUBLISH = 'verwijder',
}

@Component({
  selector: 'card-snack',
  template:'<span class="card-snack mat-headline">{{message}}</span>',
  styles: ['.card-snack { color: white; text-align: center}'],
})
export class CardSnackComponent {

  message: string;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: { message: string }) {
    this.message = data.message;
  }
}



// WEBPACK FOOTER //
// ./src/app/remote/game/game.component.ts